<template>
  <v-col
    v-if="formElement.show"
    v-bind="colProps"
    :class="{ 'py-sm-2': formElement.vertical, 'py-sm-1': !formElement.vertical, }"
    class="form-element-container py-2"
  >
    <div
      class="d-flex align-self-center"
      :class="{ 'flex-column': formElement.vertical || $vuetify.breakpoint.xsOnly }"
    >
      <!-- DEV NOTE: Consider adding section title under formElement.label standardised object -->
      <div
        v-if="formElement.label.show || formElement.sectionTitle"
        class="form-element-label text-break"
        :style="{ 'width': formElement.vertical ? undefined : labelSize }"
      >
        <BaseLabelElement :element="formElement" :translation-parent-key="resource" />
      </div>
      <div
        v-if="!formElement.onlyLabel"
        class="form-element-content"
        :class="{ 'pt-2': formElement.vertical }"
        :style="{ 'width': formElement.vertical ? undefined : elementSize }"
      >
        <template v-if="formElement.onlyShow">
          <BaseShowElement
            v-on="$listeners"
            :value="get(showData, formElement.key)"
            :showData.sync="showData"
            :showElement="formElement"
            :translationParentKey="resource"
            class="generated-show-element"
          >
            <template v-for="(_, scopedSlotName) in $scopedSlots" #[scopedSlotName]="slotData">
              <slot :name="scopedSlotName" v-bind="slotData" />
            </template>
            <template v-for="(_, slotName) in $slots" #[slotName]>
              <slot :name="slotName" />
            </template>
          </BaseShowElement>
        </template>
        <template v-else>
          <BaseFormElement
            v-model="localValue"
            v-on="mergedListeners"
            :formElement="formElement"
            :component-type="componentType"
            :translationParentKey="resource"
            :show-data="formElement.as === 'nestedForm' ? get(showData, formElement.key) : undefined"
          >
            <template v-for="(_, scopedSlotName) in $scopedSlots" #[scopedSlotName]="slotData">
              <slot :name="scopedSlotName" v-bind="slotData" />
            </template>
            <template v-for="(_, slotName) in $slots" #[slotName]>
              <slot :name="slotName" />
            </template>
          </BaseFormElement>
        </template>
      </div>
    </div>
  </v-col>
</template>

<script>
import { has, get } from 'lodash';
import localValue from '@/mixins/localValue';

export default {
  mixins: [localValue],
  props: {
    formElement: {
      type: Object,
      required: true,
    },
    showData: {
      type: Object,
      default: () => ({}),
    },
    resource: {
      type: String,
      default: '',
    },
    customLabelSize: {
      type: Object,
      default: () => ({})
    },
    componentType: {
      type: [String, Object, Function],
      default: undefined,
    },
  },
  computed: {
    mergedListeners() {
      return { ...this.formElement?.listeners, ...this.$listeners };
    },
    colProps() {
      return this.formElement.cols || {};
    },
    elementSize() {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs':
          return '100%';
        case 'sm':
          return '70%';
        default:
          return '60%';
      }
    },
    labelSize() {
      const DEFAULT_LABEL_SIZE = '40%'

      const breakpoint = this.$vuetify.breakpoint.name
      if (this.customLabelSize && this.customLabelSize[breakpoint]) {
        return this.customLabelSize[breakpoint]
      }
      switch (this.$vuetify.breakpoint.name) {
        case 'xs':
          return '100%';
        case 'sm':
          return '30%';
        case 'xl':
          return this.customLabelSize.xl || DEFAULT_LABEL_SIZE;
        default:
          return DEFAULT_LABEL_SIZE;
      }
    },
  },
  methods: {
    has,
    get,
  },
}
</script>
<style lang="scss" scoped>
.form-element-container {
  display: grid;
}
.form-element-content {
  flex-grow: 1;
  align-content: center;
  display: grid;
  @include show-form-element-value-border-color;
}
.form-element-label {
  padding-right: 16px;
  align-content: center;
  display: grid;
}
.generated-show-element {
  @include show-form-element-value-border;
  @include show-form-element-value-border-color;
}
</style>